<template>

</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
    };
  },
  methods: {
    logOut() {
      // swal
      //   .fire({
      //     title: "Are you sure?",
      //     type: "warning",
      //     showCancelButton: true,
      //     confirmButtonClass: "md-button md-success",
      //     cancelButtonClass: "md-button md-danger",
      //     confirmButtonText: "Logout",
      //     buttonsStyling: false,
      //   })
      //   .then((result) => {
      //     if (result.value) {
      const { dispatch } = this.$store;
      dispatch("authentication/logout", {
        root: true,
      });
      //     }
      //   });
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>